import { lockBody, unlockBody, SetVhElement } from "@plugins";

const options = {
    reserveScrollBarGap: true,
};

const inner = document.querySelector(".js-header-search-inner");
const searchWindow = document.querySelector(".js-header-search");
const searchActivate = document.querySelector(".js-open-search");
const searchClose = document.querySelector(".js-close-search");
const buttons = [searchActivate, searchClose];

new SetVhElement(searchWindow);

function toggleModal() {
    if (!searchWindow.classList.contains("active")) {
        openModal();
    } else {
        closeModal();
    }
}

function openModal() {
    searchWindow.classList.add("active");
    if (window.innerWidth - searchWindow.offsetWidth > 0) {
        if (inner) inner.style.paddingRight = `${window.innerWidth - searchWindow.offsetWidth}px`;
    }
    lockBody(searchWindow, options);

    // Фокус не ставится, если устанавливать его без таймаута
    // Убрал в рамках задачи № 54003
    // searchField.addEventListener("focus", () => {
    //     searchField.placeholder = "";
    // });
    // searchField.addEventListener("blur", () => {
    //     searchField.placeholder = "Поиск";
    // });

    // setTimeout(function () {
    //     searchField.focus();
    // }, 70);
}

function closeModal() {
    if (searchWindow.classList.contains("active")) {
        searchWindow.classList.remove("active");
        inner.removeAttribute("style");
        unlockBody(searchWindow);
    }
}

for (const button of buttons) {
    button.addEventListener("click", () => {
        toggleModal();
    });
}

document.addEventListener("keyup", (e) => {
    if (e.key === "Escape" && searchWindow.classList.contains("active")) {
        toggleModal();
    }
});
